import React from 'react'

export const ProjectItemPreview = () => (
  <div className="project-item__image">
    <div className="project-item__image__empty" />
  </div>
)
